import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import TestimonialSlider from '@segment/templates/TestimonialSlider'

import { customerData } from './data'

const copy = {
  heading: `Thousands of startups trust Segment`,
  description: `Startups, from early-stage to unicorn, use Segment as their single hub to collect, manage and route analytics data. Learn more in our startup stories.`,
}

const ThousandsTrustSegment: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description>{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <TestimonialSlider data={customerData} title={false} innerStyles={false} />
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSection = styled(SectionBase)`
  max-width: 1260px;
  overflow-x: visible;
`

export default ThousandsTrustSegment
